import { render, staticRenderFns } from "./Cansancio.vue?vue&type=template&id=08d0eb3f&"
import script from "./Cansancio.vue?vue&type=script&lang=js&"
export * from "./Cansancio.vue?vue&type=script&lang=js&"
import style0 from "./Cansancio.vue?vue&type=style&index=0&id=08d0eb3f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports